"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReadyState;
(function (ReadyState) {
    ReadyState[ReadyState["CLOSED"] = 0] = "CLOSED";
    ReadyState[ReadyState["OPENING"] = 1] = "OPENING";
    ReadyState[ReadyState["OPEN"] = 2] = "OPEN";
})(ReadyState || (ReadyState = {}));
exports.default = ReadyState;
//# sourceMappingURL=ready-state.js.map